// import router from 'vue-router'

const actions = {
  // checkIfProductIsKnownInOrder: ({state}, payload) => {
  //   return _.find(state.products, (product) => {
  //     if(product.product.product_number == payload.barcode && product.orderId == payload.orderId) {
  //
  //     }
  //   })
  // }


}

export default actions

